import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { ConfigService as SharedService } from "@shared/config.service";
import { AppConfig } from "@platform/app-config";

@Injectable({ providedIn: "root" })
export class NavigationConfigService extends SharedService {
  constructor() {
    const http = inject(HttpClient);
    const appConfig = inject(AppConfig);

    super(http, appConfig.coreApiEndpoint);
  }
}
